var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewScorerPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4168_5360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4168_5360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65975 1.305C8.193 1.8225 8.49375 2.52825 8.5845 3.387L8.661 3.3825C9.13732 3.36511 9.61422 3.37262 10.0898 3.405C10.1108 2.48775 10.1205 1.50075 10.1228 0.45675C9.75067 0.405192 9.37563 0.377884 9 0.375C8.2095 0.375 7.44675 0.4905 6.71925 0.69075C7.03725 0.828 7.365 1.0185 7.65975 1.305ZM7.8405 3.4365C7.764 2.76825 7.5345 2.229 7.137 1.84275C6.57825 1.3005 5.8425 1.16475 5.481 1.13325C4.42333 1.60968 3.47216 2.29375 2.68394 3.14484C1.89572 3.99593 1.28652 4.9967 0.8925 6.08775C2.25225 4.85925 4.8585 3.7095 7.8405 3.4365ZM13.1865 4.026C14.7082 4.535 16.0968 5.37781 17.2508 6.49275C16.7534 4.86459 15.7865 3.41946 14.4713 2.3385C14.0895 2.51925 13.392 2.988 13.1865 4.026ZM10.872 0.58575C10.8706 1.55559 10.8591 2.5254 10.8375 3.495C11.3886 3.56278 11.9344 3.66828 12.471 3.81075C12.6885 2.835 13.2645 2.2035 13.815 1.848C12.9221 1.24597 11.9236 0.81774 10.872 0.58575ZM4.14075 9.894C5.71725 8.0895 7.65675 5.868 7.8555 4.1895C4.5585 4.50675 1.71075 5.95725 0.84825 7.248C0.812824 7.29945 0.764942 7.34108 0.709071 7.36902C0.653201 7.39695 0.591164 7.41028 0.52875 7.40775C0.427984 7.93255 0.37651 8.46562 0.375 9C0.375 10.6057 0.82425 12.1057 1.5915 13.3942C1.88175 12.4867 2.8965 11.3182 4.14075 9.894ZM13.1325 4.77075C13.1708 6.22725 13.821 7.74675 14.4548 9.219C15.1808 10.9035 15.9225 12.6315 15.774 14.322C16.9726 12.807 17.6248 10.9318 17.625 9C17.625 8.634 17.5943 8.2755 17.55 7.92075C16.2293 6.29325 14.6783 5.3205 13.1325 4.77075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0669 4.15357C9.60764 4.12232 9.14701 4.11506 8.68695 4.13182L8.61045 4.13632C8.46645 6.07732 6.47445 8.36182 4.7052 10.3876C3.4977 11.7691 2.2497 13.1971 2.2497 13.8751C2.24922 13.9308 2.23607 13.9857 2.21125 14.0356C2.18644 14.0855 2.1506 14.1291 2.10645 14.1631C3.32656 15.7931 5.08354 16.9393 7.06695 17.3993C9.05595 14.3198 9.86295 10.9426 10.0662 4.15357H10.0669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 9.51661C13.0824 7.92961 12.3751 6.28861 12.3751 4.63711C12.3751 4.60186 12.3826 4.57336 12.3834 4.53961C11.8686 4.39819 11.3446 4.29293 10.8151 4.22461C10.6096 10.9544 9.81464 14.4179 7.86914 17.5431C8.24039 17.5919 8.61539 17.6256 8.99939 17.6256C11.1931 17.6256 13.1919 16.7954 14.7151 15.4424C15.5161 13.6064 14.6724 11.6189 13.7656 9.51661Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewScorerPage);
export default __webpack_public_path__ + "static/media/view_scorer_page.ecf5c8db5c27eb113155994f2f17c6c5.svg";
export { ForwardRef as ReactComponent };